import { InjectionToken } from '@angular/core';

export const MOCK_API_DEFAULT_DELAY = new InjectionToken<number>(
	'MOCK_API_DEFAULT_DELAY'
);
